<ng-template #itemTemplate let-item>
    <div #optionElement [ngClass]="{ 'highlight-item': highlightItemCheck(item, optionElement) }">
        <span *ngIf="item?.postalAddress?.recipient">
            {{ item?.postalAddress?.recipient }}
        </span>
        <!-- <span class=""></span> set min width and put i in it -->
        <i
            [ngClass]="{ 'opacity-0': !item.isFavorite }"
            pTooltip="{{
                item.isFavorite ? ('postal-address.is-favorite-tooltip' | translate) : ''
            }}"
            class="fa-solid fa-star text-blue-600 me-1"
        ></i>
        <!-- <span *ngIf="item?.address?.name && !item?.postalAddress?.recipient">{{item?.address?.name}}</span> -->
        <!-- <span *ngIf="(item?.address?.firstName || item?.address?.lastName) && !item?.postalAddress?.recipient">
                {{item?.address?.firstName ? item?.address?.firstName : ''}}
                <span *ngIf="item?.address?.firstName && item?.address?.lastName">{{" "}}</span>
                {{item?.address?.lastName ? item?.address?.lastName : ""}}</span> -->
        <span
            *ngIf="
                item?.postalAddress?.recipient &&
                (item?.postalAddress?.street ||
                    item?.postalAddress?.postalCode ||
                    item?.postalAddress?.city)
            "
            >{{ ',' }}
        </span>
        <span *ngIf="item?.postalAddress">
            {{ item?.postalAddress?.street ? item?.postalAddress?.street : '' }}
            {{ item?.postalAddress?.streetNumber ? ' ' + item?.postalAddress?.streetNumber : '' }}
            <span
                *ngIf="
                    item?.postalAddress?.street &&
                    (item?.postalAddress?.postalCode || item?.postalAddress?.city)
                "
                >{{ ',' }}</span
            >
            {{ item?.postalAddress?.postalCode ? item?.postalAddress?.postalCode : '' }}
            <span *ngIf="item?.postalAddress?.postalCode && item?.postalAddress?.city">{{
                ' '
            }}</span>
            {{ item?.postalAddress?.city ? item?.postalAddress?.city : '' }}
        </span>
    </div>
</ng-template>
<ng-template #selectedItemTemplate let-item>
    <span *ngIf="item?.address?.name">{{ item?.address?.name }}</span>
    <!-- <span *ngIf="(item?.address?.firstName || item?.address?.lastName) && !item?.postalAddress?.recipient">
                {{item?.address?.firstName ? item?.address?.firstName : ''}}
                <span *ngIf="item?.address?.firstName && item?.address?.lastName">{{" "}}</span>
                {{item?.address?.lastName ? item?.address?.lastName : ""}}</span> -->
    <span
        *ngIf="
            item?.postalAddress?.recipient &&
            (item?.postalAddress?.street ||
                item?.postalAddress?.postalCode ||
                item?.postalAddress?.city)
        "
        >{{ ',' }}
    </span>
    <span *ngIf="item?.postalAddress">
        {{ item?.postalAddress?.street ? item?.postalAddress?.street : '' }}
        {{ item?.postalAddress?.streetNumber ? ' ' + item?.postalAddress?.streetNumber : '' }}
        <span
            *ngIf="
                item?.postalAddress?.street &&
                (item?.postalAddress?.postalCode || item?.postalAddress?.city)
            "
            >{{ ',' }}</span
        >
        {{ item?.postalAddress?.postalCode ? item?.postalAddress?.postalCode : '' }}
        <span *ngIf="item?.postalAddress?.postalCode && item?.postalAddress?.city">{{ ' ' }}</span>
        {{ item?.postalAddress?.city ? item?.postalAddress?.city : '' }}
    </span>
</ng-template>
